module.exports = __webpack_public_path__ + "static/media/IMG_3981-2.447c4200.jpg";